import {
  Companion_getInstancemf79zpjlrrjp as Companion_getInstance,
  WebAuthNMediationType_Conditional_getInstance1yuuoant32x as WebAuthNMediationType_Conditional_getInstance,
  WebAuthNMediationType_Optional_getInstance1bk3j7584tcjj as WebAuthNMediationType_Optional_getInstance,
} from '../webAuthN.mjs';
import {
  StartRequest3klm3ah1ehn7q as StartRequest,
  ProveRequestesb0i3d4v1f2 as ProveRequest,
} from '../../../../../lightning-server-sessions-shared/com/lightningkite/lightningserver/sessions/proofs/WebAuthN.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { printStackTrace214c8iyv3cpiv5 as printStackTrace2 } from '../../../../../kiteui-library/com/lightningkite/kiteui/debugger.js.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Companion_getInstance23x6zslwzj0st as Companion_getInstance_0 } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { Frame1e7t2kcdb3wu7 as Frame } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Frame.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { ActivityIndicatork1oa7i2hevyv as ActivityIndicator } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ActivityIndicator.commonHtml.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ProofComponent2u514n64q2oz3 as ProofComponent } from './ProofComponent.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function WebAuthNProofComponent$earlyProof$slambda(this$0) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    var tmp;
    if (!(yield* Companion_getInstance().getClientAuthenticator_w0xstu_k$().autofillAvailable_8yoauv_k$($completion))) {
      return null;
    }
    var response = yield* this$0.p_1.start_cy6iof_k$(new (StartRequest())(this$0.type_1), $completion);
    var signedChallenge = yield* Companion_getInstance().getClientAuthenticator_w0xstu_k$().getWebAuthNCredentials_hcy6qc_k$(response.options_1, WebAuthNMediationType_Conditional_getInstance(), $completion);
    return yield* this$0.p_1.prove_7gsw9i_k$(new (ProveRequest())(response.challengeId_1, signedChallenge), $completion);
  }), 0);
}
function WebAuthNProofComponent$render$slambda(this$0, $proofs, $onResult) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    var tmp;
    try {
      var tmp0 = $proofs;
      var tmp$ret$0;
      $l$block: {
        // Inline function 'kotlin.collections.lastOrNull' call
        var iterator = tmp0.listIterator_70e65o_k$(tmp0.get_size_woubt6_k$());
        while (iterator.hasPrevious_qh0629_k$()) {
          var element = iterator.previous_l2dfd5_k$();
          if (!(element.via_1 === this$0.via_1)) {
            tmp$ret$0 = element;
            break $l$block;
          }
        }
        tmp$ret$0 = null;
      }
      var _destruct__k2r9zo = yield* this$0.p_1.start_cy6iof_k$(new (StartRequest())(this$0.type_1, tmp$ret$0), $completion);
      var key = _destruct__k2r9zo.component1_7eebsc_k$();
      var getOptions = _destruct__k2r9zo.component2_7eebsb_k$();
      var signedChallenge = yield* Companion_getInstance().getClientAuthenticator_w0xstu_k$().getWebAuthNCredentials_hcy6qc_k$(getOptions, WebAuthNMediationType_Optional_getInstance(), $completion);
      var result = yield* this$0.p_1.prove_7gsw9i_k$(new (ProveRequest())(key, signedChallenge), $completion);
      tmp = $onResult(result);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Exception()) {
        var e = $p;
        printStackTrace2(e);
        tmp_0 = $onResult(null);
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return Unit_instance;
  }), 1);
}
var WebAuthNProofComponentClass;
function WebAuthNProofComponent() {
  if (WebAuthNProofComponentClass === VOID) {
    class $ {
      constructor(p, type, usePasskeyUI) {
        this.p_1 = p;
        this.type_1 = type;
        this.usePasskeyUI_1 = usePasskeyUI;
        this.icon_1 = Companion_getInstance_0().passkey_1;
        this.via_1 = this.p_1.get_via_18itzv_k$();
        this.property_1 = this.p_1.get_property_msvula_k$();
        var tmp = this;
        var tmp_0;
        if (this.usePasskeyUI_1) {
          tmp_0 = WebAuthNProofComponent$earlyProof$slambda(this);
        } else {
          tmp_0 = null;
        }
        tmp.earlyProof_1 = tmp_0;
      }
      get_icon_wont8i_k$() {
        return this.icon_1;
      }
      get_via_18itzv_k$() {
        return this.via_1;
      }
      get_property_msvula_k$() {
        return this.property_1;
      }
      get_primaryIdentifierRequired_12mtun_k$() {
        return true;
      }
      *supported_g7dhny_k$($completion) {
        return yield* Companion_getInstance().getClientAuthenticator_w0xstu_k$().webAuthNAvailable_bdf5dj_k$($completion);
      }
      name_vv06me_k$(isPrimary) {
        return this.usePasskeyUI_1 && isPrimary ? 'Use Passkey' : 'Use Security Key';
      }
      get_earlyProof_n45gpi_k$() {
        return this.earlyProof_1;
      }
      render_7yvau5_k$(to, primaryIdentifier, checks, onResult) {
        return this.render_7hnxhp_k$(to, primaryIdentifier, checks, emptyList(), onResult);
      }
      render_7hnxhp_k$(to, primaryIdentifier, checks, proofs, onResult) {
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (Frame())(to.get_context_h02k06_k$());
        ensureOutermostElement(element);
        to.willAddChild_hz2iwc_k$(element);
        // Inline function 'com.lightningkite.kiteui.views.direct.activityIndicator' call
        var this_0 = get_centered(element);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (ActivityIndicator())(this_0.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        this_0.willAddChild_hz2iwc_k$(element_0);
        element_0.onStartup_vrxh3i_k$();
        this_0.addChild_2qpft2_k$(element_0);
        launch(element, VOID, VOID, WebAuthNProofComponent$render$slambda(this, proofs, onResult));
        element.onStartup_vrxh3i_k$();
        to.addChild_2qpft2_k$(element);
      }
      render_1v1gc7_k$(to, primaryIdentifier, option, onResult) {
        return this.render_7hnxhp_k$(to, primaryIdentifier, null, emptyList(), onResult);
      }
      toString() {
        return 'WebAuthNProofComponent(p=' + toString(this.p_1) + ', type=' + this.type_1 + ', usePasskeyUI=' + this.usePasskeyUI_1 + ')';
      }
      hashCode() {
        var result = hashCode(this.p_1);
        result = imul(result, 31) + getStringHashCode(this.type_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.usePasskeyUI_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof WebAuthNProofComponent()))
          return false;
        if (!equals(this.p_1, other.p_1))
          return false;
        if (!(this.type_1 === other.type_1))
          return false;
        if (!(this.usePasskeyUI_1 === other.usePasskeyUI_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'WebAuthNProofComponent', VOID, VOID, [ProofComponent()], [0]);
    WebAuthNProofComponentClass = $;
  }
  return WebAuthNProofComponentClass;
}
//region block: exports
export {
  WebAuthNProofComponent as WebAuthNProofComponent1mqorb4klgfjg,
};
//endregion

//# sourceMappingURL=WebAuthNProofComponent.mjs.map
